module.exports = __webpack_public_path__ + "img/water_recovered_with_text.b9be884b.png";